<template>
  <div id="app">
    <router-view v-slot="{ Component, route }">
      <keep-alive :include="cachedViews">
        <component :is="Component" :key="route.path" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      // Only cache pages where stale data is acceptable
      // Announcements + Messages are EXCLUDED — they need fresh data every visit
      cachedViews: [
        'ClientDashboard',
        'ClientDocuments',
        'ClientTasks',
        'ClientAppointments'
      ]
    };
  }
};
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: 'Public Sans', sans-serif; }
#app { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }
</style>